import { render, staticRenderFns } from "./PageEducatorInstitutionClassroomInactiveStudent.vue?vue&type=template&id=394b006c&scoped=true&"
import script from "./PageEducatorInstitutionClassroomInactiveStudent.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionClassroomInactiveStudent.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionClassroomInactiveStudent.vue?vue&type=style&index=0&id=394b006c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b006c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VRow})
